const Config = {
    site: "TLC Production",
    subTitle: "SubTitle",
    url: "https://www.tlcchurchproduction.com",
    description: "Tlc Production site",
    keywords: "Media Production",
    logo: "/img/logo/adayalogo.png",//"https://i.imgur.com/1UDpSHj.png",
    postPerPage: 8,
    googleAnaltics: "",
    endpoint: "https://tlcmedia-b3cb34e37a69.herokuapp.com/"
}
module.exports = Config;
